import { components, type OptionProps } from 'react-select';
import { Check } from 'lucide-react';

import type { TOption } from '../types';

export const CustomOption = (props: OptionProps<TOption>) => {
  const { data, isSelected } = props;

  return (
    <components.Option {...props}>
      {data.label}
      {isSelected && <Check className="w-3 text-action" />}
    </components.Option>
  );
};
